const leverageUiColors = {
    main: '#C6FCA6',
    bg1: '#081B28',
    bg2: '#04121C',
    mainLight: '#E2FFD1',
    main10: 'rgba(198, 252, 166, 0.10)',
    mainDark: '#9FDB7A',
    neutralWhite: '#FFF',
    neutralGrey: '#668295',
    neutralDarkBlue: '#102C3F',
    neutralLightBlue: '#2E4454',
    neutralNight: '#091C2A',
    statusUp: '#15C187',
    statusDown: '#FF3E62',
    statusDown10: 'rgba(255, 62, 98, 0.10)',
    statusWarning: '#FF984E'
};

export default leverageUiColors;